import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { IssueCard } from "./IssueCard";
import { ArrowRightIcon } from "@radix-ui/react-icons";
import { SkeletonList } from "./SkeletonList";
import { appNavigate } from "../utils/appNavigation";
import { getInterventionDate } from '../utils/interventionDate';
import { useIssueColors } from "../hooks";

const RecentIssuesList = ({ issues, issuesLoading = false, onIssueClick, getStatusColor, serviceDeskConfig }) => {
  const { t } = useTranslation();
  const { getRequestTypeColor } = useIssueColors({ serviceDeskConfig });

  return (
    <div className="p-4 pt-7 relative rounded-4xl border-0">
      <div className="h-[6px] w-[36px] bg-gray-300 absolute left-1/2 -translate-x-1/2 top-[14px] rounded-full"></div>
      <div className="flex items-start justify-between px-1 mb-4 mt-0 pt-0">
        <h3 className="text-[22px] font-normal text-gray-900">{t('Latest requests')}</h3>
        {(Array.isArray(issues) && issues.length > 0) && (
          <div>
            <Link
              onClick={() => {
                appNavigate('issues');
              }}
              to="/issues"
              className="block flex flex-row items-center gap-1 w-full py-2 text-center text-sm font-medium text-gray-900 hover:text-gray-700 transition-colors"
            >
              {t('See more')} <ArrowRightIcon className="w-[14px] h-[14px]" />
            </Link>
          </div>
        )}
      </div>
      <div className="space-y-2">
        {!issues.length && issuesLoading ? (
          <SkeletonList numberOfItems={6} />
        ) : issues.length === 0 && !issuesLoading ? (
          <div className="flex flex-col items-center justify-center py-8 text-center text-gray-500">
            <div className="w-10 h-10 rounded-full border border-dashed border-gray-300 flex items-center justify-center mb-3">
              <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" strokeWidth="1.5" strokeDasharray="4 4"/>
              </svg>
            </div>
            <p className="text-sm font-medium text-gray-700">{t('No recent request!')}</p>
            <p className="text-xs text-gray-400 mt-1">
              {t('Create a first request to see it appear here.')}
            </p>
          </div>
        ) : (
          [...issues]
            .sort((a, b) => new Date(b.fields.updated) - new Date(a.fields.updated))
            .map((issue) => {
              const statusColor = issue.fields.statusCategory?.colorName || getStatusColor(issue.fields.status);

              return (
                <div key={issue.key} className="space-y-2">
                  <IssueCard
                    color={getRequestTypeColor(issue.mappedFields.requestType?.requestType)}
                    issueKey={issue.key}
                    dueDate={getInterventionDate(issue)}
                    status={issue.fields.status.name}
                    statusColor={statusColor}
                    summary={issue.mappedFields.title}
                    interventionPoint={issue.mappedFields.intervention_point}
                    createdAt={issue.fields.created}
                    onClick={() => {
                      appNavigate('issues', { issueKey: issue.key });
                      onIssueClick(issue.key, issue);
                    }}
                  />
                </div>
              );
            })
        )}
      </div>
    </div>
  );
};

export { RecentIssuesList };

